import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/less";
import "swiper/less/navigation";
import "swiper/less/pagination";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import { Navigation } from "swiper";
import { Link } from "react-router-dom";
import "./MySwiper.scss";

const MySwiper = (props) => {
  return (
    <>
      <section className="header-section">
        <div className="header-content-parent">
          {props?.slideImages?.length > 0 && (
            <Swiper
              navigation={true}
              modules={[Navigation]}
              className="mySwiper"
              loop={true}
              autoplay={{
                delay: 1000,
                disableOnInteraction: false,
              }}
            >
              {props?.slideImages?.map((v, index) => {
                return (
                  <SwiperSlide key={index + "slide"}>
                    <Link to={v.link}>
                      <img src={v.url} alt="" style={{ width: "100%" }} />
                    </Link>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
        </div>
      </section>
    </>
  );
};

export default MySwiper;
